import { Container } from '@pixi/react'
import { GodziDropIcon } from '@slot-nx/core'
import { useGodziDropStore } from '../../domain/godzi/store/godziDropStore'
import { useState, useEffect, memo } from 'react'
import { threecomboolympusMachine } from '../../domain/machine/threecomboolympusMachine'

export const GodziDropControl = memo(() => {
  const [isIconOpen] = useGodziDropStore(state => [state.isIconOpen])
  const [isEnable, setIsEnable] = useState(threecomboolympusMachine.getSnapshot().matches('init game'))

  useEffect(() => {
    const subscription = threecomboolympusMachine.subscribe((snapshot) => {
      if (snapshot.matches('init game')) {
        setIsEnable(true)
      }
      else {
        setIsEnable(false)
      }
    })
    return () => {
      subscription.unsubscribe()
    }
  }, [])
  return (
    <Container name="GodziDropControl">
      <GodziDropIcon
        isIconOpen={isIconOpen}
        isEnable={isEnable}
        onPress={() => useGodziDropStore.setState({ isShowDashboard: true })}
      />
    </Container>
  )
})
